// extracted by mini-css-extract-plugin
export var leftAlign = "_1p-2";
export var popper = "_1p-0";
export var subtitle = "_1p-1";